import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  Grid,
  Badge,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

import ProductCard from "./components/ProductCard";
import CategoryCard from "./components/CategoryCard";
import Slider from "react-slick";
import {
  Get_Quick_Sales_Category,
  Get_Quick_Sales_Items,
} from "../../Server/Apis";
import { httpRequest } from "../../Server/Axios";
import { CmpSelectFieldV1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import { useDispatch, useSelector } from "react-redux";
import { setCategories } from "./sliceOrderTakingCar";
import { common_locaitonlist_API } from "../../Server/ApiV2";
import { useNavigate } from "react-router-dom";
import theme from "../../Theme";

const CustomNextArrow = ({ onClick }) => (
  <button
    className="custom-arrow next-arrow"
    onClick={onClick}
    style={{ backgroundColor: theme.palette.primary.main }}
  >
    <ArrowForwardIosIcon />
  </button>
);

const CustomPrevArrow = ({ onClick }) => (
  <button
    className="custom-arrow prev-arrow"
    onClick={onClick}
    style={{ backgroundColor: theme.palette.primary.main }}
  >
    <ArrowBackIosIcon sx={{ marginLeft: "6px" }} />
  </button>
);

const sliderProps = {
  dots: false,
  infinite: true,
  lazyLoad: true,
  speed: 500,
  slidesToShow: 9,
  slidesToScroll: 1,
  arrows: true,
  swipeToSlide: true,
  nextArrow: <CustomNextArrow />,
  prevArrow: <CustomPrevArrow />,
  responsive: [
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 9,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 940,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 797,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 699,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 424,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
};

const OrderTaking = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedLoc, setSelectedLoc] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [locations, setLocations] = useState([]);
  const [products, setProducts] = useState([]);

  const { cartList } = useSelector((state) => state.sliceCart);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const { categories } = useSelector((state) => state.sliceOrderTakingCar);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const baseUrl = vRdxDBKernObj.IMAGE_BASE_URL?.Val;

  const getCategory = async () => {
    try {
      const payload = Get_Quick_Sales_Category();
      let res = await httpRequest(payload);
      if (res.Type === "Success" && res.ResultSet.length > 0) {
        const uniqueCategories = res.ResultSet.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.Cd === item.Cd)
        );
        dispatch(setCategories(uniqueCategories));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeLoc = (value) => {
    setSelectedLoc(value);
  };

  const handleSearch = async (catCd = "") => {
    try {
      if (selectedLoc) {
        const payload = Get_Quick_Sales_Items({
          Loc: selectedLoc,
          Grp: catCd ? catCd : "", // Use passed category or selected one
          SearchText: searchQuery || "", // Allow search query or empty
        });
        const res = await httpRequest(payload);
        if (res.Type === "Success" && res.ResultSet.length > 0) {
          setProducts(res.ResultSet); // Ensure empty array if no results
        } else {
          setProducts([]); // Clear products if API fails
        }
      }
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    setProducts([]);
    setSelectedCategory(null);
  };

  const renderCartIcon = useMemo(
    () => (
      // <Grid item sx={{ marginLeft: "auto" }}>
      <Badge
        badgeContent={cartList.length}
        color="error"
        overlap="circular"
        sx={{
          "& .MuiBadge-badge": {
            right: 4,
            top: 4,
            fontSize: "0.75rem",
            minWidth: "20px",
            height: "20px",
          },
        }}
      >
        <IconButton
          color="primary"
          sx={{
            backgroundColor: "#f5f5f5",
            p: 1.5,
            border: "1px solid",
            "&:hover": { backgroundColor: "#e0e0e0" },
          }}
          onClick={() => navigate("/cart")}
        >
          <AddShoppingCartIcon />
        </IconButton>
      </Badge>
      // </Grid>
    ),
    [cartList, navigate]
  );

  const getLocation = useCallback(async () => {
    let locationList = await common_locaitonlist_API({
      usercd: vRdxuserInfo.UserID,
    });
    if (locationList?.status === 200) {
      if (locationList.data?.ResultSet?.length > 0) {
        setLocations(locationList?.data?.ResultSet);
        setSelectedLoc(locationList?.data?.ResultSet[0]?.UId);
      }
    }
  }, [vRdxuserInfo.UserID]);

  // Ensure the category is updated and products are fetched on selection
  const handleCategoryChange = async (catCd) => {
    setSelectedCategory(catCd);
    await handleSearch(catCd);
  };

  useEffect(() => {
    console.log("products", products);
  }, [products]);

  useEffect(() => {
    getLocation();
    getCategory();
  }, []);

  return (
    <>
      <Grid
        container
        spacing={{ xs: 0.5, sm: 1 }}
        sx={{ flexGrow: 1, my: { xs: 0.5, sm: 0.8 }, alignItems: "center" }}
      >
        <Grid item xs={12} sm={6} md={6}>
          <CmpSelectFieldV1
            xLabelText="locations"
            xValue={selectedLoc}
            xOnChange={(e) => {
              handleChangeLoc(e?.target?.value);
            }}
            xName={"loc"}
            xData={locations ?? []}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <TextField
            placeholder="Search for products..."
            value={searchQuery}
            size="small"
            onChange={(e) => setSearchQuery(e?.target?.value)}
            InputProps={{
              endAdornment: (
                <>
                  {searchQuery && (
                    <InputAdornment position="end">
                      <IconButton onClick={clearSearch}>
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  )}
                </>
              ),
            }}
            sx={{ width: "100%" }}
          />
          <IconButton
            sx={{ padding: "5px", mx: { xs: 1, sm: 2 } }}
            color="primary"
            onClick={async () => await handleSearch()}
          >
            <SearchIcon color="primary" />
          </IconButton>
          {renderCartIcon}
        </Grid>
      </Grid>
      {sliderProps && (
        <div className="carousel-container">
          <Slider {...sliderProps}>
            {categories?.map((category) => (
              <CategoryCard
                baseUrl={baseUrl}
                key={category?.Cd}
                category={category}
                selectedCategory={selectedCategory}
                setCategoryId={handleCategoryChange}
              />
            ))}
          </Slider>
        </div>
      )}
      {(selectedCategory || searchQuery) && (
        <Grid
          container
          spacing={{ xs: 2 }}
          sx={{
            justifyContent: { xs: "center", md: "flex-start" },
            marginTop: "8px !important",
          }}
        >
          {products?.map((product, index) => (
            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              lg={2.4}
              key={index}
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-start" },
              }}
            >
              <ProductCard product={product} baseUrl={baseUrl} />
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default OrderTaking;
